import React, { memo } from "react";
import { useDropzone } from "react-dropzone";
import { ButtonBase, Paper } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { CloudUpload } from "../icons";

const useStyles = makeStyles((theme) => ({
  root: ({ color }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    whiteSpace: "normal",
    padding: theme.spacing(3),
    color: color
      ? theme.palette[color]?.main
      : theme.palette.background.disabled,
  }),
  icon: ({ color }) => ({
    height: "auto",
    width: "40%",
    maxWidth: 300,
    maxHeight: "100%",
    color: color
      ? theme.palette[color]?.main
      : theme.palette.background.disabled,
  }),
  messageBox: ({ color }) => {
    let textColor;
    switch (color) {
      case "success":
        textColor = theme.palette.primary.main;
        break;
      case "error":
        textColor = theme.palette.error.main;
      default:
        textColor = theme.palette[color]?.main || theme.palette.text.disabled;
    }
    const borderColor =
      theme.palette[color]?.main || theme.palette.background.disabled;
    return {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      border: `1px solid ${borderColor}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1.5, 2),
      backgroundColor: alpha(borderColor, 0.05), // add transparency
      color: textColor,
      fontWeight: 500,
    };
  },
}));

function DropZone({
  className,
  label,
  activeLabel,
  Icon = CloudUpload,
  disabled,
  color,
  variant,
  dataTestId,
  ...rest
}) {
  const classes = useStyles({ color });

  const { getRootProps, getInputProps } = useDropzone({ disabled, ...rest });

  return (
    <ButtonBase
      {...getRootProps()}
      disabled={disabled}
      variant={variant}
      component={Paper}
      className={classNames(className, classes.root)}
    >
      <input
        data-test-id={dataTestId}
        {...getInputProps()}
        disabled={disabled}
      />
      <Icon className={classes.icon} />
      <div className={classes.messageBox}>{label}</div>
    </ButtonBase>
  );
}

export default memo(DropZone);
